import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center gap-2 px-6 py-16">
      <h2 className="font-heading font-semibold text-xl text-ink">{title}</h2>
      {description && <p className="font-body text-base text-muted max-w-xs">{description}</p>}
      {action}
    </div>
  );
}
